import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TaskService } from 'src/app/services/task.service';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import { DatePipe, Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GeneralService } from 'src/app/services/general.service';
import { MapInformationService } from "src/app/services/map-information.service";

@Component({
  selector: 'app-create-update-task',
  templateUrl: './create-update-task.component.html',
  styleUrls: ['./create-update-task.component.scss']
})
export class CreateUpdateTaskComponent implements OnInit {

  _formNewTask: FormGroup = new FormGroup({
    taskid: new FormControl({ value: 0, disabled: false }, []),
    name: new FormControl({ value: '', disabled: false }, []),
    projectid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    employeeid: new FormControl({ value: '', disabled: false }, []), // !!
    taskresources : new FormControl({ value: [], disabled: false }, []),
    statusid: new FormControl({ value: 0, disabled: false }, []),
    todocategoryid: new FormControl({ value: 0, disabled: false }, []),
    priorityid: new FormControl({ value: 0, disabled: false }, []),
    area: new FormControl({ value: '', disabled: false }, []),
    phaseid: new FormControl({ value: 0, disabled: false }, []),
    estimatedcost: new FormControl({ value: 0, disabled: false }, []),
    startdate: new FormControl({ value: new Date(), disabled: false }, []),
    estimatedtime: new FormControl({ value: 0, disabled: false }, [Validators.pattern('[0-500][0-9]:[0-9][0-9]')]),
    duedate: new FormControl({ value: new Date(), disabled: false }, []),
    completionperc: new FormControl({ value: 0, disabled: false }, []),
    endofmonthproj: new FormControl({ value: 0, disabled: false }, []),
    completiondate: new FormControl({ value: '', disabled: false }, []),
    notes: new FormControl({ value: '', disabled: false }, []),
    sort: new FormControl({ value: 0, disabled: false }, []),
    locationid: new FormControl({ value: 0, disabled: false }, []),
    vendorid: new FormControl({ value: 0, disabled: false }, []),
    summarytaskid: new FormControl({ value: 0, disabled: false }, []),
    user: new FormControl({ value: '', disabled: false }, []),
    projectaddress: new FormControl({ value: '', disabled: false }, []),
    projectname: new FormControl({ value: '', disabled: false }, []),
    createon: new FormControl({ value: new Date(), disabled: false }, []),
    resources : new FormControl('', []),
    milestonename : new FormControl(false, []),
  });

  searchModeOption: string = "contains";
  searchExprOptionItems: Array<any> = [{
    name: "'Name'",
    value: "Name"
  }, {
      name: "['Name']",
      value: ['Name']
  }]
  searchTimeoutOption: number = 200;
  minSearchLengthOption: number = 0;

  milestone: boolean = false;
  categorySelect: any = [];
  statusSelect: any = [];
  prioritySelect: any = [];
  employeeSelect: any = [];
  phasesSelect: any = [];
  locationSelect: any = [];
  projectslist: CustomStore;
  @Input() popupTask = false;

  now = new Date();
  //
  dateValue: number;
  todayButton: any;
  prevDateButton: any;
  nextDateButton: any;
  millisecondsInDay = 24 * 60 * 60 * 1000;
  today = new Date().getTime();
  resources: any;

  //Inputs Fecha
  startDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: null };
  dueDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };
  completionDate = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: null };

  @Input() hideButtons = false;
  // @Input() project = {
  //   projectid: 0,
  //   projectname: '',
  //   projectnumber: ''
  // };
  private _project: any;
  @Input('project')
  set project(project: any) {
    this._project = project;
    if (project && project.projectid > 0) {
      this.isprojectview = true;
      this.setProjectInfo(project);
    }
  }

  get project(): any { return this._project; }

  @Output() onsubmit = new EventEmitter<any>();
  @Output() onresources = new EventEmitter<any>();
  @Output() closemodal = new EventEmitter<any>();
  @Output() ocultarSave = new EventEmitter<any>();
  @Input() fromQuickAccess: any;

  isprojectview = false;

  private _task: any;
  summarytaskSelect: any = [];
  subcontractors = [];

  taskid: any;

  @Input('task')
  set task(task: any) {
    this._task = task;
    if (task.ID > 0) {
      this.taskid = task.ID;
      console.log('ESTOY EN TASK ', task)
      task.notes = task.notes.replace(/<br>/g,'\n');
      this.taskService.GetTaskEmployees().subscribe(result => {
        this.employeeSelect = result;
        this.setForm(task);
        this.checkMilestone();
      });
    }
  }
  lastLocation: any;
  dateFormat: any;
  moneyFormat: any;
  disableInputs = false;
  get task(): any { return this._task; }

  primeraVez: boolean = false;

  disableDate: boolean = true;

  defaultPhase: any = 0;

  editLinkButton: any;
  externalLink: any;

  defaultPhaseid: any = 0;
  defaultPriorityid: any = 0;
  defaultCategoryid: any = 0;
  defaultLocationid: any = 0;
  defaultStatusid: any = 0;

  primeravez: boolean = false;

  defaultValues = [];
  employeesWithAlert: any;

  openModalAlert: boolean = false;

  defaultDuration: any = 0;
  defaultStartDate: any;

  @Input() blockMilestone = false;
  disableMilestone: boolean = false;

  timeSheet: any = [];

  disableInputMilestone: boolean = false;

  editando: boolean = true;


  items: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color", "background", "link", "clear", "codeBlock", "blockquote", "separator", "insertTable", "deleteTable",
    "insertRowAbove", "insertRowBelow", "deleteRow", "insertColumnLeft", "insertColumnRight",
    "deleteColumn", "cellProperties", "tableProperties",
  ];

  constructor(
    private router: Router,
    public location:Location,
    private datepipe: DatePipe,
    private toast: ToastService,
    private taskService: TaskService,
    private appconfig: AppConfigService,
    private activatedRoute: ActivatedRoute,
    private generalService: GeneralService,
    public settingsCompany: CompanySettingsService,
    private MapInformationService:MapInformationService,
    private translate:TranslateService
  ) {

    // console.log('Constructor')
    this.taskService.GetTaskEmployees().subscribe(result => {
      this.employeeSelect = result
    });

    this.inputsDate(this.startDate, null);
    this.inputsDate(this.dueDate, null);
    this.inputsDate(this.completionDate, null);
    this.dateFormat = this.appconfig.dateFormat + ' HH:mm';
    this.moneyFormat = this.appconfig.moneyFormat;

    this.editLinkButton = {
      icon: 'fa fa-link',
      type: 'default',
      onClick: () => {
        this.externalLink = this.externalLink.trim();
        if(this.externalLink!=='' && this.externalLink!==undefined){
          window.open(this.externalLink, "_blank");
        }
      },
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(changes.project!==undefined && changes.project.previousValue!==undefined){
      this._project= changes.project.currentValue;
      // this.ngOnInit();
    }

    if(changes.blockMilestone!== undefined && changes.blockMilestone.currentValue !== undefined){
      this.checkMilestone();
      console.log(changes.blockMilestone)
      this.disableInputMilestone = changes.blockMilestone.currentValue;
      if(changes.blockMilestone.currentValue == true){
        this._formNewTask.get('milestonename').setValue(false);
        this.updateTask();
      }
    }
  }

  inputsDate(date, showdate) {
    if(showdate!==null){
      let year = this.datepipe.transform(showdate, 'yyyy');
      date.showDate =  parseInt(year)<1990 ? new Date().getTime() : new Date(showdate).getTime() ;
    }else{ date.showDate = showdate; }

    date.todayButton = {
      text: this.translate.instant('btnToday'),
      onClick: () => {
        date.showDate =  new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null? this.today-this.millisecondsInDay : date.showDate -= this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null? this.today+this.millisecondsInDay : date.showDate += this.millisecondsInDay;
      }
    };
  }

  limpiarmodalTask() {
    this.popupTask = false;
    this.closemodal.emit();
    this.initForm();
    // this.setDefaultSettings();
    this._formNewTask.get('projectaddress').setValue(this.project.ADDRESS)
    this._formNewTask.get('projectname').setValue(this.project.NAME);
  }

  limpiarModalCompletas(){
    // console.log('Limpiar MOdal desde Quick Access')
    this.popupTask = false;
    this.closemodal.emit();
    this.initForm();
    this.project = null;
  }

  ngOnInit() {
    // console.log('Ngonit ');
    this.primeraVez = true;
    this.activatedRoute.queryParams.subscribe(params => {
      this.lastLocation = params['tab'];
    })

    if(this.categorySelect.length==0){
      this.taskService.GetTaskCategoriesFlex().subscribe(result => { this.categorySelect = result; });
    }

    if(this.statusSelect.length==0){
      this.taskService.GetTaskStatus().subscribe(result => { this.statusSelect = result; });
    }

    if(this.prioritySelect.length==0){
      this.taskService.GetTaskPriorities().subscribe(result => { this.prioritySelect = result; console.log('Priorities ', result) });
    }

    if(this.phasesSelect.length==0){
      this.taskService.GetTaskPhases().subscribe(result => { this.phasesSelect = result; });
    }

    if(this.locationSelect.length==0){
      this.taskService.GetTaskLocation().subscribe(result => { this.locationSelect =  result; });
    }
    // if(this.fromQuickAccess){
      this.setDefaultSettings();
    // }

    if (this.project && this.project.projectid > 0) {
      // console.log(this.project)
      this.setProjectInfo(this.project);
      this.isprojectview = true;
    }

    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.taskService.GetProjectByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  checkMilestone(){
    this.taskService.GetTimeSheetsByTask(this.task.ID).subscribe(result => {
      console.log('Time Sheet ', result);
      this.timeSheet = result;
      if(result.length > 0){
        console.log('Disable Milestone ');
        this.disableInputMilestone = true;
      }
    })
  }

  changeMilestone(e){
    if(e!==undefined){
      this._formNewTask.get('milestonename').setValue(e);
      if(this.timeSheet.length == 0 && e == true){
        this.disableMilestone = true;
        this._formNewTask.get('estimatedtime').setValue('00000');
        let startDate = this._formNewTask.get('startdate').value;
        this._formNewTask.get('duedate').setValue(startDate);
        console.log('Actualizar data ');
      }else{
        this.disableMilestone = false;
      }
    }
  }

  setDefaultSettings(){
    // console.log('Default Settings de Create Task ');

    this.settingsCompany.GetClientSettings("DefaultProjectToDoLocation").subscribe(result=>{
      this.defaultLocationid = Number(result[0].VALUE);
      if (!this._formNewTask.get('locationid').value || this._formNewTask.get('locationid').value == 0)
        this._formNewTask.get('locationid').setValue(this.defaultLocationid);
    })

    this.settingsCompany.GetClientSettings("ProjectEstimatingPhase").subscribe(result=>{
      this.defaultPhaseid = Number(result[0].VALUE);
      if (!this._formNewTask.get('phaseid').value || this._formNewTask.get('phaseid').value == 0)
        this._formNewTask.get('phaseid').setValue(this.defaultPhaseid);
    })

    this.settingsCompany.GetClientSettings("DefaultProjectToDoPriority").subscribe(result=>{
      this.defaultPriorityid = Number(result[0].VALUE);
      if (!this._formNewTask.get('priorityid').value || this._formNewTask.get('phaseid').value == 0)
        this._formNewTask.get('priorityid').setValue(this.defaultPriorityid);
    })

    this.settingsCompany.GetClientSettings("DefaultProjectToDoStatus").subscribe(result=>{
      this.defaultStatusid = Number(result[0].VALUE);
      if (!this._formNewTask.get('statusid').value || this._formNewTask.get('statusid').value == 0)
        this._formNewTask.get('statusid').setValue(this.defaultStatusid);
    })

    this.settingsCompany.GetClientSettings("DefaultProjectToDoCategory").subscribe(result=>{
      this.defaultCategoryid = Number(result[0].VALUE);
      if (!this._formNewTask.get('todocategoryid').value || this._formNewTask.get('todocategoryid').value == 0)
        this._formNewTask.get('todocategoryid').setValue(this.defaultCategoryid);
    })
  }

  getSubContractors(projectid) {
    this.taskService.GetSubContractors(projectid).subscribe(result => {
      this.subcontractors = result;
      // console.log('SubContractors ', result);
    })
  }
  getSummaryTask(projectid) {
    this.taskService.GetSummaryTask(projectid).subscribe(result => {
      this.summarytaskSelect = result.map(x=>{
        x.NAME = x.ID+'-'+x.NAME;
        return x;
      });
      // console.log('Summarys ', this.summarytaskSelect);
    })
  }
  // range slider
  format(value) {
    return value + "%";
  }

  initForm(item?: any) {
    // console.log('Init Foorm');
    this._formNewTask = new FormGroup({
      taskid: new FormControl({ value: 0, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, []),
      projectid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      employeeid: new FormControl({ value: '', disabled: false }, []), // !!
      taskresources : new FormControl({ value: [], disabled: false }, []),
      statusid: new FormControl({ value: this.defaultStatusid, disabled: false }, []),
      todocategoryid: new FormControl({ value: this.defaultCategoryid, disabled: false }, []),
      priorityid: new FormControl({ value: this.defaultPriorityid, disabled: false }, []),
      area: new FormControl({ value: '', disabled: false }, []),
      phaseid: new FormControl({ value: this.defaultPhaseid, disabled: false }, []),
      estimatedcost: new FormControl({ value: 0, disabled: false }, []),
      startdate: new FormControl({ value: new Date(), disabled: false }, []),
      estimatedtime: new FormControl({ value: 0, disabled: false }, [Validators.pattern('[0-9][0-9]:[0-9][0-9]')]),
      duedate: new FormControl({ value: new Date(), disabled: false }, []),
      completionperc: new FormControl({ value: 0, disabled: false }, []),
      endofmonthproj: new FormControl({ value: 0, disabled: false }, []),
      completiondate: new FormControl({ value: '', disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
      sort: new FormControl({ value: 0, disabled: false }, []),
      locationid: new FormControl({ value: this.defaultLocationid, disabled: false }, []),
      vendorid: new FormControl({ value: 0, disabled: false }, []),
      summarytaskid : new FormControl({ value: 0, disabled: false }, []),
      user: new FormControl({ value: localStorage.getItem('username'), disabled: false }, []),
      // userid: new FormControl({ value: localStorage.getItem('customerid'), disabled: false }, []),
      createon: new FormControl({ value: new Date(), disabled: false }, []),
      projectaddress: new FormControl({ value: '', disabled: false }, []),
      projectname: new FormControl({ value: '', disabled: false }, []),
      milestonename: new FormControl({ value: false, disabled: false }, []),
      // resourceArray: new FormControl('', []),
    });

    // this.changeDueDate();
  }

  rebootForm(){
    this._formNewTask = new FormGroup({
      taskid: new FormControl({ value: 0, disabled: false }, []),
      name: new FormControl({ value: '', disabled: false }, []),
      projectid: new FormControl({ value: '', disabled: false }, [Validators.required]),
      employeeid: new FormControl({ value: '', disabled: false }, []), // !!
      taskresources : new FormControl({ value: [], disabled: false }, []),
      statusid: new FormControl({ value: this.defaultStatusid, disabled: false }, []),
      todocategoryid: new FormControl({ value: this.defaultCategoryid, disabled: false }, []),
      priorityid: new FormControl({ value: this.defaultPriorityid, disabled: false }, []),
      area: new FormControl({ value: '', disabled: false }, []),
      phaseid: new FormControl({ value: this.defaultPhaseid, disabled: false }, []),
      estimatedcost: new FormControl({ value: 0, disabled: false }, []),
      startdate: new FormControl({ value: new Date(), disabled: false }, []),
      estimatedtime: new FormControl({ value: 0, disabled: false }, [Validators.pattern('[0-9][0-9]:[0-9][0-9]')]),
      duedate: new FormControl({ value: new Date(), disabled: false }, []),
      completionperc: new FormControl({ value: 0, disabled: false }, []),
      endofmonthproj: new FormControl({ value: 0, disabled: false }, []),
      completiondate: new FormControl({ value: '', disabled: false }, []),
      notes: new FormControl({ value: '', disabled: false }, []),
      sort: new FormControl({ value: 0, disabled: false }, []),
      locationid: new FormControl({ value: this.defaultLocationid, disabled: false }, []),
      vendorid: new FormControl({ value: 0, disabled: false }, []),
      summarytaskid : new FormControl({ value: 0, disabled: false }, []),
      user: new FormControl({ value: localStorage.getItem('username'), disabled: false }, []),
      // userid: new FormControl({ value: localStorage.getItem('customerid'), disabled: false }, []),
      createon: new FormControl({ value: new Date(), disabled: false }, []),
      projectaddress: new FormControl({ value: '', disabled: false }, []),
      projectname: new FormControl({ value: '', disabled: false }, []),
      milestonename: new FormControl({ value: false, disabled: false }, []),
      // resourceArray: new FormControl('', []),
    });
  }

  setForm(item?: any) {
    // console.log('Set item ',item);
    this.editando = true;
    this.isprojectview = true;
    this.disableInputs = item.STATUSID == 3;
    this.disableMilestone = this.disableInputs;
    this.disableInputs == false? this.disableInputMilestone = false : '';
    this.resources = item.resourcesIDs ? item.resourcesIDs.split(',').map(x => +x) : [];
    // console.log('Recursos ', this.resources);
    if (this.disableInputs)
      this.ocultarSave.emit();

    if (!this.project )
      this.project = {};
    this.project.projectid = item.PROJECTID;
    this.project.projectname = item.PROJECTNAME;
    this.summarytaskSelect = this.summarytaskSelect.filter(x => x.PROJECTID == item.PROJECTID);
    this.inputsDate(this.startDate, item.StartDate);
    (item.COMPLETIONPERC*100) == 100 ? item.COMPDATE : item.COMPDATE = null;
    this.inputsDate(this.completionDate, item.COMPDATE);
    // item.duration = item.duration ? '00.'+item.duration : '00.00';

    let durat = item.duration ? item.duration.toString().split('.') : ['0', '0'];
    console.log("🚀 ~ file: create-update-task.component.ts:495 ~ CreateUpdateTaskComponent ~ setForm ~ durat:", durat)

    if(durat[1]!==undefined && durat[1]!==null){

      let hours, minutes;
      let hours_initial = durat[0].substr(0, 1);

      if(hours_initial==0){
        hours = durat[0].substr(1, 2);
        hours.length == 0 ? hours = '000' : '';

        minutes = durat[1].substr(0, 2);
        minutes.length == 1 ? minutes = minutes+'0' : '';

      }else{
        hours = durat[0].substr(0, 3);

        hours.length == 2 ? hours = '0'+hours : '';
        hours.length == 1 ? hours = '00'+hours : '';
        minutes = durat[1].substr(0, 2);

        minutes.length == 1 ? minutes = minutes+'0' : '';
      }
      
      item.duration = hours+minutes;
      console.log("🚀 ~ file: create-update-task.component.ts:519 ~ CreateUpdateTaskComponent ~ setForm ~ item.duration :", item.duration )
    }else{
      item.duration.toString().length > 3 ? item.duration = item.duration+'0' : '';
      item.duration.toString().length == 3 ? item.duration = item.duration+'00' : '';
      item.duration.toString().length == 2 ? item.duration = '0'+item.duration+'00' : '';
      item.duration.toString().length == 1 ? item.duration = '00'+item.duration+'00' : '';
    }
    console.log("duration??  ", item.duration);
    item.MILESTONENAME =  item.MILESTONENAME == null || item.MILESTONENAME == 'false' || item.MILESTONENAME == 'False' ? false : true;

    this.defaultDuration = item.duration;
    this.defaultStartDate = this.datepipe.transform(item.StartDate, 'yyyyMMdd');

    this.changeMilestone(item.MILESTONENAME);

    this.inputsDate(this.dueDate, item.DUEDATE);
    console.log('Due Date ', new Date(this.dueDate.showDate));
    console.log("COMPELTION PERC ", item.COMPLETIONPERC*100);
    this._formNewTask = new FormGroup({
      taskid: new FormControl({ value: item.ID, disabled: false }, []),
      name: new FormControl({ value: item.TASKNAME, disabled: false }, []),
      projectid: new FormControl({ value: item.PROJECTID, disabled: false }, [Validators.required]),
      employeeid: new FormControl({ value: item.REPONSIBLEID == undefined ? 0:item.REPONSIBLEID, disabled: false }, []),
      taskresources: new FormControl({ value: item.resourcesIDs ? item.resourcesIDs.split(',') : [], disabled: false }, []),
      statusid: new FormControl({ value: item.STATUSID == null ? this.defaultStatusid : item.STATUSID, disabled: false }, []),
      todocategoryid: new FormControl({ value: item.TODOCATEGORYID == null ? this.defaultCategoryid : item.TODOCATEGORYID, disabled: false }, []),
      priorityid: new FormControl({ value: item.PRIORITYID == null ? this.defaultPriorityid : item.PRIORITYID, disabled: false }, []),
      area: new FormControl({ value: item.area, disabled: false }, []),
      phaseid: new FormControl({ value: item.PHASEID == null ? this.defaultPhaseid : item.PHASEID, disabled: false }, []),
      estimatedcost: new FormControl({ value: item.estimatecost, disabled: false }, []),
      startdate: new FormControl({ value: this.startDate.showDate, disabled: false }, []),
      estimatedtime: new FormControl({ value: item.duration, disabled: false }, [Validators.pattern('[0-500][0-9]:[0-9][0-9]')]),
      duedate: new FormControl({ value: this.dueDate.showDate, disabled: false }, []),
      completionperc: new FormControl({ value: (item.COMPLETIONPERC*100), disabled: false }, []),
      endofmonthproj: new FormControl({ value: (item.ENDOFMNTHPROJ*100), disabled: false }, []),
      completiondate: new FormControl({ value: this.completionDate.showDate, disabled: false }, []),
      notes: new FormControl({ value: item.notes, disabled: false }, []),
      sort: new FormControl({ value: item.order, disabled: false }, []),
      locationid: new FormControl({ value: item.LOCATIONID, disabled: false }, []),
      vendorid: new FormControl({ value: item.VENDORID, disabled: false }, []),
      summarytaskid: new FormControl({ value: item.SUMMARYTASKID, disabled: false }, []),
      user: new FormControl({ value: item.createdbyname, disabled: false }, []),
      resources : new FormControl('', []),
      projectaddress: new FormControl({ value: item.projectaddress, disabled: false }, []),
      projectname: new FormControl({ value: item.PROJECTNAME, disabled: false }, []),
      createon: new FormControl({ value: this.datepipe.transform(item.OPENDATE, 'yyyy-MM-dd  HH:mm'), disabled: false }, []),
      milestonename: new FormControl({ value: item.MILESTONENAME, disabled: false }, []),
    });
    console.log(this._formNewTask.get("completionperc").value);

    this.notesData = item.notes

    this.getSummaryTask(this.project.projectid);
    this.getSubContractors(this.project.projectid);

    this.onResourcesChange(item.resourcesIDs ? item.resourcesIDs.split(',').map(Number) : []);

    setTimeout(() => {
      this.editando = false;
    }, 1000);
  }

  deleteResourcesNotFound(res){
    // console.log(res);
    let finalData = [...res];
    res.forEach((data, i)=>{
      let found = this.employeeSelect.find(x=> x.ID == data);
      if(found){
        finalData.splice(i,1);
      }
    })
    this.resources = finalData.join(',');
    // console.log('Resources ', this.resources);
    // console.log('Final Resources ', finalData);
  }

  onResourcesChange(ev) {
    if (ev && this.employeeSelect) {
      let contacts = this.employeeSelect.filter(x => ev.includes(x.ID));
      this.onresources.emit(contacts);
    }
  }

  onStatusChange(ev) {
    if (ev.value == 3) {
      if (this._formNewTask.get('completionperc').value < 100) {
        this.toast.warning(this.translate.instant('msgComp100'));
      }
      if (!this._formNewTask.get('completiondate').value) {
        this.toast.warning(this.translate.instant('msgCompDate'));
      }
    }
  }

  validateForm() {
    let hasError = false;
    let value = this._formNewTask.value;

    if (!value.projectid) {
      this.toast.warning(this.translate.instant('msgProjName'));
      hasError = true
    }

    if (value.statusid == 3) {
      if (value.completionperc < 100) {
        this.toast.warning(this.translate.instant('msgComp100'));
        hasError = true
      }
      if (!value.completiondate) {
        this.toast.warning(this.translate.instant('msgCompDate'));
        hasError = true
      }
    }

    return hasError;
  }

  setProjectInfo(item) {
    if (item) {
      this._formNewTask.get('projectid').setValue(item.projectid);
      this.getSubContractors(item.projectid);
      this.getSummaryTask(item.projectid);
    }
  }

  updateTask(visibleModal = false, goedit = false, volver = false) {

    console.log(visibleModal, ' Go edit ', goedit, ' Volver ', volver);

    if (this.validateForm())
      return;

    let values = this._formNewTask.value;
    console.log("FORM TASK ? ", values);
    if (!values.name) {
      values.name = 'New Task';
      return
    }

    let datetime = this.datepipe.transform(values.startdate, 'yyyyMMdd');
    let edit = false;
    if(this.defaultDuration >=8 && datetime == this.defaultStartDate){
      edit = true;
    }

    // console.log('Task Resources ', values);

    // let alertEmployees = [];
    // if(values.taskresources !== undefined && values.taskresources.length > 0){
    //   values.taskresources.map((x, i)=>{
    //     console.log('X ', x);
    //     this.taskService.GetTaskHoursByResource(x, datetime).subscribe(data=>{
    //       console.log('Resources alert ', data);
    //       if(data[0].totalhour >= 8 && edit == false){
    //         let found = this.employeeSelect.find(employee => employee.ID === x);
    //         if(found){
    //           alertEmployees.push(found.CONTACTNAME);
    //         }
    //       }
    //       console.log(values.taskresources.length, ' / ', i+1);
    //       if(values.taskresources.length === i+1){
    //         this.defaultValues = [values, visibleModal, goedit, volver];
    //         if(alertEmployees.length == 0){
              this.saveTask(values, visibleModal, goedit, volver);
    //         }else{
    //           this.employeesWithAlert = alertEmployees.join(',');
    //           console.log('Estos empleados ya tienen 8 horas de tareas ', this.employeesWithAlert);
    //           this.openModalAlert = true;
    //         }
    //       }
    //     })
    //   })
    // }else{
    //   this.defaultValues = [values, visibleModal, goedit, volver];
    //   this.saveTask(values, visibleModal, goedit, volver);
    // }
  }

  initValidationAlert(){
    this.openModalAlert = false;
    this.employeesWithAlert = '';
  }

  saveTask(values, visibleModal = false, goedit = false, volver = false){
    if(typeof values.estimatedtime== 'string' && values.estimatedtime!==''){
      let hours, minutes;
      let hours_initial = values.estimatedtime.substr(0, 1);
      if(hours_initial==0){
        hours = values.estimatedtime.substr(1, 2);
        minutes = values.estimatedtime.substr(3, 2);
      }else{
        hours = values.estimatedtime.substr(0, 3);
        minutes = values.estimatedtime.substr(3, 2);
      }
      values.estimatedtime = hours+'.'+minutes;
    }
    values.completionperc = values.completionperc/100;
    values.endofmonthproj = values.endofmonthproj/100;
    values.locationid = values.locationid ? values.locationid : 0;
    values.phaseid = values.phaseid ? values.phaseid : 0;
    values.vendorid = values.vendorid ? values.vendorid : 0;
    values.estimatedcost = values.estimatedcost ? values.estimatedcost : 0;
    values.summarytaskid = values.summarytaskid  ? values.summarytaskid  : 0;
    values.completiondate = this.datepipe.transform(values.completiondate, 'yyyyMMdd hh:mm:ss');

    // if(values.createon!== null && values.createon!== undefined  && this._task !== undefined){
    //   values.createon = this.datepipe.transform(this._task.WORKDATE, 'yyyyMMdd hh:mm:ss');
    // }
    // values.createon = values.createon ? this.datepipe.transform(this._task.WORKDATE, 'yyyyMMdd hh:mm:ss'): '';
    values.startdate = this.datepipe.transform(values.startdate, 'yyyyMMdd hh:mm:ss');
    values.duedate = this.datepipe.transform(values.duedate, 'yyyyMMdd hh:mm:ss');
    values.sort = values.sort == null || values.sort == '' ? 0 : values.sort;
    this._formNewTask.get('sort').setValue(values.sort);
    values.resources = (values.taskresources && values.taskresources.length > 0) ? values.taskresources.join(',') : '0';
    values.method = 'Insert_Task_ce';

    values.notes = values.notes.replace(/\n/g, '<br>');
    
    console.log('Guardando... ',values);
    this.taskService.updateTask2(values).subscribe(result => {

      // this.taskService.updateDueDateTwoWeek(values.taskid).subscribe(resultDueDate=>{

        let id = result[0].Column1;
        this.toast.success(this.translate.instant('msgTaskUpdSucc'));
        this.initForm();
        // if (this.lastLocation !== 'Task') {
          this.ngOnInit();
          console.log('GoEdit ', goedit)
          if (goedit) {
            this.router.navigateByUrl(`/taskManagement/editTask?numID=${id}&numTODOID=${id}`)
            this.onsubmit.emit(false);
            return;
          }

        // }
        this.onResourcesChange(values.resources);

        this.onsubmit.emit(visibleModal);

        if(volver){
          if(this.lastLocation=='Task'){
            let previousUrl = this.generalService.currentUrl.value;

            if (previousUrl && previousUrl.toLocaleLowerCase().includes('editproject')) {
              this.router.navigate(['editProject'], { queryParams: { numID: this.project.projectid, tab: 'Task'}});
            } else {
              this.location.back();
            }
          }else if (this.lastLocation=='TaskManagement'){
            this.router.navigate(['taskManagement'], { queryParams: { tab: 'Task List'} });
          }else if (this.lastLocation=='Gantt View'){
            this.router.navigate(['taskManagement'], { queryParams: { tab: 'Gantt View'} });
          }else{
            this.location.back();
          }
        }
      // })
    })
  }

  updateProjectInfo(item) {
    // console.log(item)
    if (item.selectedItem && item.selectedItem.ID) {
      this._formNewTask.get('projectid').setValue(item.selectedItem.ID);
      // console.log('Actualizando id project')
      this.getSummaryTask(item.selectedItem.ID);
      this.getSubContractors(item.selectedItem.ID);
    }
  }

  changeDueDate(){
    console.log("update due")

    if(this.editando !== true){

      let duration = this._formNewTask.get('estimatedtime').value;
      duration== null || duration == '' ? duration = '00000' : '';
      let startDate = new Date(this._formNewTask.get('startdate').value);
      let resources = 0
      if (this.resources != undefined){
        resources = this.resources.length;
      }
      let porcentaje = this._formNewTask.get('completionperc').value;
      porcentaje == 0 ? porcentaje = porcentaje / 100 : porcentaje;

      resources == 0 ? resources = 1 : resources;

      let hours;
      let minutes;
      console.log("DURATION ", duration);
      let hours_initial = duration.toString().substr(0, 1);
      if(hours_initial==0){
        hours = duration.toString().substr(1, 2);
        minutes = duration.toString().substr(3, 2);
      }else{
        hours = duration.toString().substr(0, 3);
        minutes = duration.toString().substr(3, 2);
      }

      console.log("HORAS ", hours);
      let durationFinal = Number(hours+'.'+minutes) == 0 ? 3 : Number(hours+'.'+minutes);

      let resto = durationFinal % 8;

      if(minutes>59){
        let finalHour = Number(minutes)/60;
        let finalMinutes: any = Number(minutes)%60;
        finalHour = Math.round(finalHour) + Number(hours);
        
        let estimatedtime;

        let legnth_hour = finalHour.toString().length;

        if(legnth_hour==1){
          estimatedtime = '00'+finalHour+finalMinutes;
        }else if(legnth_hour==2){
          estimatedtime = '0'+finalHour+finalMinutes;
        }else{
          estimatedtime = finalHour+''+finalMinutes;
        }
        estimatedtime.toString().length == 3 ? estimatedtime = estimatedtime+'00' : '';
        estimatedtime.toString().length == 4 ? estimatedtime = estimatedtime+'0' : '';

        this._formNewTask.get('estimatedtime').setValue(estimatedtime);
      }else{
        //Toma en cuenta el porcentaje de avance y se lo resta a la duracion final
        
        let days = (durationFinal / resources);
        let estimatedTime = 0;

        // console.log('Resto ', resto);
        // console.log('Dias ', days);

        if(resto == 0){
          estimatedTime = Math.round(days/8) - 1; 
        }else{
          let division = (hours / 8) % 1;
          
          estimatedTime = division == 0 ?  Math.round(days/8) : Math.floor(days/8);
        }

        Math.sign(estimatedTime) < 0 ? estimatedTime = 0 : '';
        console.log('EstimatedTime1 ', estimatedTime);

        let finalDueDate: any = new Date(startDate.setDate(startDate.getDate() + estimatedTime));

        console.log('FINAL ', finalDueDate);
        this._formNewTask.get('duedate').setValue(finalDueDate);
        this.primeraVez=true;
      }
    }
  }

  enableCompletionDate(event){
    let porcentaje = this._formNewTask.get('completionperc').value;
    if(porcentaje != event.value){
      this._formNewTask.get('completionperc').setValue(event.value);
      porcentaje = event.value;
    }
    porcentaje==100? this.disableDate = false : this.disableDate = true;
    navigator.cookieEnabled
  }

  enableRecognized(event){
    let porcentaje = this._formNewTask.get('endofmonthproj').value;
    if(porcentaje != event.value){
      this._formNewTask.get('endofmonthproj').setValue(event.value);
      porcentaje = event.value;
    }
  }


  openModalNote
  showNote(){
    this.openModalNote = true
  }


  SaveNote(){
    console.log("aquiiii")
    this.openModalNote = false
  }

  notesData:any=""
  asignarValue(event) {
    this.notesData = event.value
    this._formNewTask.get("notes").setValue(event.value)
  }

  RefreshEstimateRevenue(){
    console.log("aqui")
    console.log(this.task)
    this.MapInformationService.SaveInfoSites({method:"Update_TaskRevenue", taskid:this.taskid, taskcategoryid:this.task.TODOCATEGORYID})
    .subscribe(resp=>{
      this.toast.success("Updated Successfully")
      this.onsubmit.emit(false)
    })
    
  }

}
